import { GridColDef } from "@mui/x-data-grid-pro";

/**
 * GenerateCargoHabilidadeColumnsDefinition
 */

export const GenerateCargoHabilidadeColumnsDefinition = (): GridColDef[] => {
  return [
    {
      field: "tipo",
      filterable: false,
      headerName: "Nome",
      minWidth: 150,
      width: 300,
      sortable: false,
      renderCell: ({ value }) => {
        return (<div className="w-full h-full flex items-center">{value}</div>);
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (<div className="w-full h-full flex items-center">{value}</div>);
      }
    },
  ];
}